import { SLACK_CODE_PARAM_NAME } from '../const';

export const isSlackConfirmationQuery = (query: string) => {
  const queryParams = new URLSearchParams(query);

  return queryParams.has(SLACK_CODE_PARAM_NAME);
};
